import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import LabelFormat, { DefaultLabelFormat } from '~/types/LabelFormat';
import PackingSlipFormat from '~/types/PackingSlipFormat';

export type LabelSettingsState = {
  readonly data: Readonly<{
    readonly defaultLabelFormat: LabelFormat;
    readonly defaultPackingSlipFormat: PackingSlipFormat;
    readonly isMergeLabelsAndPackingSlips: boolean;
    readonly refText1: string;
    readonly refText2: string;
    readonly outboundServiceLevel: string;
    readonly isRequireSignatureConfirmation: boolean;
    readonly outboundReturnLabelServiceLevel: string;
    readonly isAutoCreateReturnLabels: boolean;
    readonly isUseOrderNumber: boolean;
    readonly labelLogoType: Maybe<string>;
    readonly storePolicyText: string;
    readonly packingSlipText: string;
    readonly packingSlipShowPrices: boolean;
  }>;
  readonly isLoadingLabelSettings: boolean;
  readonly isLoadedLabelSettings: boolean;
};

export const labelSettingsInitialState: LabelSettingsState = {
  data: {
    defaultLabelFormat: DefaultLabelFormat,
    defaultPackingSlipFormat: PackingSlipFormat.PSLIP_8X11_PDF,
    isMergeLabelsAndPackingSlips: false,
    refText1: '',
    refText2: '',
    outboundServiceLevel: '',
    isRequireSignatureConfirmation: false,
    outboundReturnLabelServiceLevel: '',
    isAutoCreateReturnLabels: false,
    isUseOrderNumber: false,
    labelLogoType: null,
    storePolicyText: '',
    packingSlipText: '',
    packingSlipShowPrices: true,
  },
  isLoadingLabelSettings: false,
  isLoadedLabelSettings: false,
};

function labelSettingReducer(
  state: LabelSettingsState = labelSettingsInitialState,
  action: ActionTypes,
) {
  switch (action.type) {
    case ActionKeys.SAVE_LABEL_SETTINGS_SUCCESS:
      return {
        ...state,
        data: {
          defaultLabelFormat: action.payload.defaultLabelFormat,
          defaultPackingSlipFormat: action.payload.defaultPackingSlipFormat,
          isMergeLabelsAndPackingSlips: action.payload.isMergeLabelsAndPackingSlips,
          isUseOrderNumber: action.payload.isUseOrderNumber,
          refText1: action.payload.refText1,
          refText2: action.payload.refText2,
          outboundServiceLevel: action.payload.outboundServiceLevel,
          isRequireSignatureConfirmation: action.payload.isRequireSignatureConfirmation,
          outboundReturnLabelServiceLevel: action.payload.outboundReturnLabelServiceLevel,
          isAutoCreateReturnLabels: action.payload.isAutoCreateReturnLabels,
          labelLogoType: action.payload.labelLogoType,
          storePolicyText: action.payload.storePolicyText,
          packingSlipText: action.payload.packingSlipText,
          packingSlipShowPrices: action.payload.packingSlipShowPrices,
        },
        isLoadingLabelSettings: false,
      };
    case ActionKeys.FETCH_LABEL_SETTINGS:
      return {
        ...state,
        isLoadingLabelSettings: true,
        isLoadedLabelSettings: false,
      };
    case ActionKeys.FETCH_LABEL_SETTINGS_SUCCESS:
      return {
        ...state,
        data: {
          defaultLabelFormat: action.payload.defaultLabelFormat,
          defaultPackingSlipFormat: action.payload.defaultPackingSlipFormat,
          isMergeLabelsAndPackingSlips: action.payload.isMergeLabelsAndPackingSlips,
          isUseOrderNumber: action.payload.isUseOrderNumber,
          refText1: action.payload.refText1,
          refText2: action.payload.refText2,
          outboundServiceLevel: action.payload.outboundServiceLevel,
          isRequireSignatureConfirmation: action.payload.isRequireSignatureConfirmation,
          outboundReturnLabelServiceLevel: action.payload.outboundReturnLabelServiceLevel,
          isAutoCreateReturnLabels: action.payload.isAutoCreateReturnLabels,
          labelLogoType: action.payload.labelLogoType,
          storePolicyText: action.payload.storePolicyText,
          packingSlipText: action.payload.packingSlipText,
          packingSlipShowPrices: action.payload.packingSlipShowPrices,
        },
        isLoadingLabelSettings: false,
        isLoadedLabelSettings: true,
      };
    default:
      return state;
  }
}

export default labelSettingReducer;
